var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VSelect',_vm._b({attrs:{"value":_vm.selected,"items":_vm.list,"label":_vm.$t('headers.os'),"hint":_vm.$t('form.os_display'),"item-value":"uid"},on:{"input":function (e) { return _vm.$emit('input', e); }},scopedSlots:_vm._u([{key:"selection",fn:function(ref){
var ref_item = ref.item;
var platform = ref_item.platform;
var version = ref_item.version;
return [_c('VChip',[_vm._v(_vm._s(platform)+" "+_vm._s(version))])]}},{key:"item",fn:function(ref){
var ref_item = ref.item;
var platform = ref_item.platform;
var version = ref_item.version;
return [_vm._v("\n    "+_vm._s(platform)+" "+_vm._s(version)+"\n  ")]}}])},'VSelect',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }